import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=46b8d5ba&scoped=true&"
import script from "./Configuracion.vue?vue&type=script&lang=js&"
export * from "./Configuracion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dropfile.css?vue&type=style&index=0&id=46b8d5ba&prod&scoped=true&lang=css&"
import style1 from "./Configuracion.vue?vue&type=style&index=1&id=46b8d5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8d5ba",
  null
  
)

export default component.exports